module.exports = new __parcel__URL__("banner_twitter.d6d5a4a2.png").toString();